var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormMedia',{staticClass:"mb-2 h-50",attrs:{"context":_vm.context},on:{"saved":_vm.onSaved}})}
var staticRenderFns = []

export { render, staticRenderFns }